import { useQuery } from '@tanstack/react-query';
import { useStudentAuth } from '@/frontend/contexts/StudentAuthContext';
import { getConsumptionByStudent } from '@/backend/services/energyConsumption';
import type { EnergyConsumption } from '@/shared/types/energy';

/**
 * Hook to fetch energy consumption records for the current student.
 * staleTime inherits the global 0 so every mount and every invalidation
 * triggers a fresh fetch from Firestore.
 */
export function useMyConsumption() {
  const { user } = useStudentAuth();

  return useQuery<EnergyConsumption[]>({
    queryKey: ['my-consumption', user?.uid],
    queryFn: async () => {
      if (!user?.uid) return [];
      return getConsumptionByStudent(user.uid);
    },
    enabled: !!user?.uid,
  });
}
